import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { CancelButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";

interface ArchivedUsersModalFormProps {
  onClose: () => Promise<void>;
}

const ArchivedUsersModalForm: FunctionComponent<
  ArchivedUsersModalFormProps
> = ({ onClose }) => {
  const methods = useForm();

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: onClose, align: "left" },
  ];

  return (
    <Form methods={methods} onSubmit={async () => {}}>
      <FormButtons buttons={buttons} />
    </Form>
  );
};

export default ArchivedUsersModalForm;
